const validate = (value: string | number, { decimals }: Record<string, any>): boolean => {
    const parts = String(value).split('.')
    if (parts.length < 2) return true
    return parts[1].length <= Number(decimals)
}

export { validate }

export default {
    validate,
    params: [{
        name: 'decimals'
    }]
}
